// extracted by mini-css-extract-plugin
export default {"wrapper":"popup_wrapper__abQI6","popupMask":"popup_popupMask__I8-kv","show":"popup_show__LNSGA","popupBody":"popup_popupBody__3Sinr"};